import { useState, useEffect, useRef } from "react";
import { Snackbar, Alert, Slide } from "@mui/material";
import toast from "../../helpers/toast";

let toastIdCounter = 0;

function SlideLeft(props) {
  return <Slide {...props} direction="left" />;
}

export default function ToastContainer() {
  const [toasts, setToasts] = useState([]);
  // Keep a ref to the latest setToasts so the subscription closure stays stable
  const setToastsRef = useRef(setToasts);
  setToastsRef.current = setToasts;

  useEffect(() => {
    const unsubscribe = toast.subscribe(({ type, message }) => {
      setToastsRef.current((prev) => {
        // Suppress duplicate: same message + type already visible
        const alreadyVisible = prev.some(
          (t) => t.open && t.type === type && t.message === message
        );
        if (alreadyVisible) return prev;
        const id = ++toastIdCounter;
        return [...prev, { id, type, message, open: true }];
      });
    });
    return unsubscribe;
  }, []);

  const handleClose = (id) => {
    setToasts((prev) => prev.map((t) => (t.id === id ? { ...t, open: false } : t)));
  };

  const handleExited = (id) => {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  };

  return (
    <>
      {toasts.map((t, index) => (
        <Snackbar
          key={t.id}
          open={t.open}
          autoHideDuration={5000}
          onClose={() => handleClose(t.id)}
          TransitionComponent={SlideLeft}
          TransitionProps={{ onExited: () => handleExited(t.id) }}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          sx={{ top: `${index * 72 + 16}px !important`, right: "16px" }}
        >
          <Alert
            onClose={() => handleClose(t.id)}
            severity={t.type}
            variant="filled"
            sx={{ width: "100%", minWidth: 300, maxWidth: 420 }}
          >
            {t.message}
          </Alert>
        </Snackbar>
      ))}
    </>
  );
}
